/* eslint-disable */
import React, { useState, useEffect, useContext, useRef } from 'react'
import { DialogContent, Dialog, DialogActions, DialogContentText, TextField, Button, IconButton } from '@mui/material'
import styled from 'styled-components'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useApi from 'common/hooks/useApi'
import { UserContext } from 'account'
import { LayoutContext } from 'common/ducks/index'
import { createEvent} from 'ics';
import { DatePicker } from '@mui/x-date-pickers'
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { CalendarMonthOutlined, InsertPhotoOutlined } from '@mui/icons-material';
import moment from 'moment'
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  Conversation,
  ConversationList,
  Avatar,
  ConversationHeader,
  ExpansionPanel,
  } from '@chatscope/chat-ui-kit-react';

export default function ConversationPopUp({open, activeChat, onOpenChange, messagesCall}) {
  const user = useContext(UserContext)
  const { setAppLoading } = useContext(LayoutContext)
  const [openDialog, setOpenDialog] = useState(false)
  const [showCalendarDialog, setShowCalendarDialog] = useState(false)
  const [date, setDate] = useState(moment())
  const [time, setTime] = useState(moment())
  const [eventTitle, setEventTitle] = useState()
  const [eventDuration, setEventDuration] = useState()
  const [eventDescription, setEventDescription] = useState()
  const [eventURL, setEventURL] = useState()
  const [titleError, setTitleError] = useState(false)
  const [dateError, setDateError] = useState(false)
  const [durationError, setDurationError] = useState(false)
  const [helperText, setHelperText] = useState('')
  const [fbToken, setFBToken] = useState('')
  const [notif, setNotif] = useState(false)
  const hiddenFileInput = useRef(null);

  const [{ loading: sendLoading }, sendMessageApi] = useApi(
      {
        method: 'POST',
        url: 'messages/',
      },
      { manual: true }
    )

  const [{ loading: uploadLoading }, upload] = useApi(
      {
        method: 'POST',
        url: 'messages/upload_media/',
      },
      { manual: true }
    )

  async function sendMessage(textContent){
     const body = {
        'sender': user.id,
        'receiver': activeChat?.id,
        'message': textContent,
        'gfbt': fbToken,
        }
     await sendMessageApi({
          data: body,
       }).then((response) => {
        if(response?.status === 201){
          response.data.direction = 'outgoing'
          response.data.sentTime = 'just now'
          activeChat.messages.push(response.data)
          messagesCall()
        }
       })
    }

  async function createCalendarEvent(obj) {
    let splitDate = date.format('YYYY-MM-DD')
    splitDate = splitDate.split('-')
    const splitTime = time.format('HH:mm').split(':')
    let event = {}
    if (obj?.type === 'click') {
      event = {
        start: [Number(splitDate[0]), Number(splitDate[1]), Number(splitDate[2]), Number(splitTime[0]), Number(splitTime[1])],
        duration: { minutes: Number(eventDuration) },
        title: eventTitle,
        description: eventDescription,
        location: 'Virtual',
        url: eventURL,
        organizer: { name: `${user?.firstName} ${user?.lastName}`, email: user?.email },
      }
    }
    if (obj.start) {
      event = {
        start: obj.start,
        duration: obj.duration,
        title: obj.title,
        description: obj.description,
        location: obj.location,
        url: obj.url,
        organizer: obj.organizer,
      }
    }
    if(!event?.title){
      setTitleError(true)
      setHelperText('Required')
    }
    if(!event?.duration?.minutes){
      setDurationError(true)
      setHelperText('Required')
    }
    const filename = 'Sidekick_Calendar_Event.ics'
    const file = await new Promise((resolve, reject) => {
    createEvent(event, (error, value) => {
      if (error) {
        return;
      }
      resolve(new File([value], filename, { type: 'text/calendar' }))
    })
  })
    const url = URL.createObjectURL(file);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);

    URL.revokeObjectURL(url);
    handleClose()
    if (!obj.start) {
      sendMessage(JSON.stringify({type: 'calendar', content: event}))
    }
  }

  function onFileChange(event) {
    if(event.target.files[0]?.size > 50000000) {
       alert("File is too big! Max size is 50 MB");
    } else if (event.target.files[0]) {
      const file = event?.target?.files[0]
      const formData = new FormData()
      formData.append('id', user?.id)
      formData.append('file', file)
      formData.append('receiver', activeChat?.id)
      formData.append('gfbt', fbToken)
      formData.append('type', file?.type)
      upload({
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      }).then((response) => {
        if (response?.status === 201){
          response.data.direction = 'outgoing'
          response.data.sentTime = 'just now'
          activeChat.messages.push(response.data)
          messagesCall()
        }
      })
    }
  }

  function handleClose() {
    setShowCalendarDialog(false)
    setHelperText('')
    setTitleError(false)
    setDateError(false)
    setDurationError(false)
    open = false
  }

  function closeDialog() {
    setOpenDialog(false)
    onOpenChange(false)
  }

  useEffect(() => {
    setOpenDialog(open)
  }, [open])

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  useEffect(() => {
        setAppLoading(sendLoading || uploadLoading)
    }, [sendLoading, uploadLoading, setAppLoading])

  return (
    <Dialog.Stylesheet
      fullScreen
      open={openDialog}
      disableEnforceFocus
    >
      <ConversationPopUp.Content style={{padding: 0}}>

        <div className="container">
          <MainContainer className="main container" style={{marginBottom: 80}}>
              <ChatContainer className="my-chat-container">
                <ConversationHeader style={{position: 'sticky', width: '100%'}}>
                  <ConversationHeader.Back onClick={() => {closeDialog()}} />
                  <ConversationHeader.Content
                    userName={activeChat?.name}
                  />
                </ConversationHeader>
                <MessageList>
                  {activeChat?.messages?.map((row) => {
                    if(row?.message) {
                      try {
                        if (!row?.message?.type){
                          const obj = JSON.parse(row?.message)
                          if (obj?.type === 'calendar'){
                            return(
                              <Message model={{
                                 message: 'CALENDAR EVENT',
                                 sentTime: row?.sentTime,
                                 direction: row?.direction,
                                 }} >
                                    <Message.CustomContent>
                                      <a onClick={() => createCalendarEvent(obj.content)}>
                                        <CalendarMonthOutlined/>
                                        CALENDAR EVENT: {obj.content.title}
                                      </a>
                                    </Message.CustomContent>
                              </Message>
                            )
                          }
                        }
                        if (row?.message?.type === 'image/png' || row?.message?.type === 'image/jpeg'){
                          return(
                            <Message model={{
                               message: '',
                               sentTime: row?.sentTime,
                               direction: row?.direction,
                               }} >
                                  <Message.CustomContent>
                                    <img src={row?.message?.content} alt="" style={{height: 300, width: 300}}/>
                                  </Message.CustomContent>
                            </Message>
                          )
                        }
                        if (row?.message?.type === 'video/mp4' || row?.message?.type === 'video/mov' || row?.message?.type === 'video/quicktime'){
                          return(
                            <Message model={{
                               message: '',
                               sentTime: row?.sentTime,
                               direction: row?.direction,
                               }} >
                                  <Message.CustomContent>
                                    <video src={row?.message?.content} controls alt="" style={{height: 300, width: 300}}/>
                                  </Message.CustomContent>
                            </Message>
                          )
                        }
                      }
                      catch (error){
                        if(!row?.message?.type){
                          if(row?.message?.includes('span')){
                            if (!row?.message?.includes('</a>')){
                              let link = row?.message?.split('>')
                              link = link[1].split('<')
                              link = link[0]
                              let linkFormat = row?.message?.split('>')
                              linkFormat[0] = '<span style="font-size: 15.04px;color: white;">'
                              linkFormat = linkFormat?.join(' ')
                              linkFormat = linkFormat?.replace('</span', '</span>')
                              row.message = linkFormat
                              row.message = `<a href=${link} style={{color: "white"}}>${row?.message}</a>`
                              }
                            return(
                              <Message model={{
                                     message: row?.message,
                                     sentTime: row?.sentTime,
                                     direction: row?.direction,
                                     type: 'html',
                                     payload: row?.message
                                     }} />
                          )
                          } else if(row?.message?.includes('http')){
                            if (!row?.message?.includes('</a>')){
                              let link = row?.message?.split('&nbsp;')
                              if (link?.includes(' ')){
                                row?.message?.split(' ')
                                row.message = `<a href=${link[0]} style="color: white;">${row?.message}</a>`
                              }
                              if (link.length > 1) {
                                row.message = `<a href=${link[1]} style="color: white;">${row?.message}</a>`
                              }
                            }
                            return(
                              <Message model={{
                                     message: row?.message,
                                     sentTime: row?.sentTime,
                                     direction: row?.direction,
                                     type: 'html',
                                     payload: row?.message
                                     }} />
                          )
                          } else {
                            return(
                              <Message model={{
                                     message: row?.message,
                                     sentTime: row?.sentTime,
                                     direction: row?.direction,
                                     }} />
                            )
                          }
                        }
                      }
                    }
                  })}
                </MessageList>
                 <div as={MessageInput} style={{display:"flex", borderTop: "1px solid #d1dbe4"}}>
                    <MessageInput style={{width: '70%'}} placeholder="Type message here" onSend={(value) => sendMessage(value)} attachButton={false}/>
                    <label style={{ margin: 5 }}>
                      <input
                        accept=".jpg,.png, .mp4, .mov"
                        type="file"
                        id="media-upload"
                        style={{ display: 'none' }}
                        onChange={onFileChange}
                        ref={hiddenFileInput}
                      />
                      <IconButton  onClick={handleClick}>
                        <InsertPhotoOutlined/>
                      </IconButton>
                    </label>
                    <IconButton onClick={() => setShowCalendarDialog(true)}>
                      <CalendarMonthOutlined/>
                    </IconButton>
                  </div>
              </ChatContainer>
            </MainContainer>
        </div>

        <Dialog onClose={() => setShowCalendarDialog(false)} open={showCalendarDialog}>
        <DialogContent>
          <DialogContentText>
            Create Event
          </DialogContentText>
            <TextField
              id="title"
              name="Title"
              label="Title"
              type="text"
              value={eventTitle}
              onChange={(e)=>{setEventTitle(e.target.value)}}
              fullWidth
              variant="standard"
              style={{marginBottom: 30}}
              error={titleError}
              helperText={helperText}
            />
            <DatePicker
                style={{minWidth: '350px', marginBottom: 30}}
                format="YYYY-MM-DD"
                inputVariant="outlined"
                label="Start Date"
                name="start-date"
                value={date}
                onChange={(value) => setDate(value)}
                fullWidth
                error={dateError}
                helperText={helperText}
            />
            <TimePicker
                style={{minWidth: '350px',marginBottom: 30}}
                format="hh:mm"
                inputVariant="outlined"
                label="Start Time"
                name="start-time"
                value={time}
                onChange={(value) => setTime(value)}
                fullWidth
                error={dateError}
                helperText={helperText}
            />
            <TextField
              id="duration"
              name="Duration"
              label="Duration (mins)"
              type="number"
              value={eventDuration}
              onChange={(e)=>{setEventDuration(e.target.value)}}
              fullWidth
              variant="standard"
              style={{marginBottom: 30}}
              error={durationError}
              helperText={helperText}
            />
            <TextField
              id="description"
              name="Description"
              label="Description"
              type="text"
              value={eventDescription}
              onChange={(e)=>{setEventDescription(e.target.value)}}
              fullWidth
              variant="standard"
              style={{marginBottom: 30}}
            />
            <TextField
              id="url"
              name="URL"
              label="URL"
              type="text"
              value={eventURL}
              onChange={(e)=>{setEventURL(e.target.value)}}
              fullWidth
              variant="standard"
              style={{marginBottom: 30}}
            />
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick={createCalendarEvent}>Create</Button>
            </DialogActions>
        </DialogContent>
      </Dialog>

      </ConversationPopUp.Content>
    </Dialog.Stylesheet>
  )
}

Dialog.Stylesheet = styled(Dialog)``

ConversationPopUp.Content = styled(DialogContent)`

  margin: 0 auto;
  padding: 0px;
  .cs-main-container {
    margin-top: 0rem;
    height: 100vh;
    width: 100vw;
    padding: 0
    padding-top: 30px;

  }
  .my-chat-container{
    height: 100vh;

  }
  .container {
    padding: 0;
  }

  .css-kw13he-MuiDialogContent-root{
  padding: 0px;
  }

  .cs-message--outgoing .cs-message__content {
  background-color: darkcyan;
  color: white !important;
}

.cs-message--incoming .cs-message__content {
  background-color: whitesmoke;
}

.cs-message-input__content-editor-wrapper{
  background-color: whitesmoke;
}

.cs-message-input__content-editor{
  background-color: whitesmoke;
}

.cs-conversation-header{
  padding-top: 40px;
  background-color: whitesmoke;
}

.cs-conversation-header__content .cs-conversation-header__user-name{
  background-color: whitesmoke;
}
`

ConversationPopUp.Stylesheet = styled.div`

  .container {
    padding: 0;
  }

  .css-kw13he-MuiDialogContent-root{
  padding: 0px;
  }
  .MuiToolbar-root {
    justify-content: flex-start;
  }
`
